import { FC } from 'react'
import { useSelector } from 'react-redux'
import { isBranchStaff } from '../../helpers/roles'
import { RootReducers } from '../../redux/reducers'

const RequireBranchStaff: FC = ({ children }) => {
  const loginState = useSelector((state: RootReducers) => state.loginReducer)

  if (!isBranchStaff(loginState.account?.agentInfo.role as string)) {
    return null
  }

  return <>{children}</>
}

export default RequireBranchStaff
